import _ from "lodash";
import moment from "moment";
import * as z from "../../../framework";
import { DropDownList, DropDownListOptions } from "./dropDownList";

type PresetDateRangeSpecifier = "this" | "last" | "last rolling";
type DateRangeType = "Date" | "DateTime";

export class PresetDateRangeDropDownList extends DropDownList {
    options: DropDownListOptions;
    changeEvents: ((startTime: string, endTime: string) => void)[];

    constructor(options: DropDownListOptions) {
        super(options);

        options.dataValueField = "Value";
        options.dataTextField = "Text";
        options.valueWidth = 150;

        this.changeEvents = [];
    }

    onChange(event: (startTime: string, endTime: string) => void) {
        var me = this;

        me.changeEvents.push(event);
    }

    build(dateRangeType: DateRangeType) {
        var me = this;

        $(`#${me.options.id}`).data("kendoDropDownList").setDataSource([
            { Text: z.ll("ChooseDateRange"), Value: "" },
            { Text: z.ll("Today"), Value: "TODAY" },
            { Text: z.ll("Yesterday"), Value: "YESTERDAY" },
            { Text: z.ll("ThisWeek"), Value: "THIS_WEEK" },
            { Text: z.ll("ThisMonth"), Value: "THIS_MONTH" },
            { Text: z.ll("ThisYear"), Value: "THIS_YEAR" },
            { Text: z.ll("ThisQuarter"), Value: "THIS_QUARTER" },
            { Text: z.ll("LastWeek"), Value: "LAST_WEEK" },
            { Text: z.ll("LastMonth"), Value: "LAST_MONTH" },
            { Text: z.ll("LastYear"), Value: "LAST_YEAR" },
            { Text: z.ll("LastQuarter"), Value: "LAST_QUARTER" },
            { Text: z.ll("LastRollingWeek"), Value: "LAST_ROLLING_WEEK" },
            { Text: z.ll("LastRollingMonth"), Value: "LAST_ROLLING_MONTH" },
            { Text: z.ll("LastRollingYear"), Value: "LAST_ROLLING_YEAR" },
            { Text: z.ll("LastRollingQuarter"), Value: "LAST_ROLLING_QUARTER" }
        ] as any);

        $(`#${me.options.id}`).data("kendoDropDownList").select(0);

        const setPresetDateRange = (specifier: PresetDateRangeSpecifier, period: moment.unitOfTime.DurationConstructor) => {
            let offset: any = 0;

            if (specifier == "last" || specifier == "last rolling") {
                offset = 1;
            }

            let startTime: string,
                endTime: string,
                startMoment: moment.Moment,
                endMoment: moment.Moment;

            if (dateRangeType == "DateTime") {
                startMoment = moment();
                endMoment = moment();
            } else if (dateRangeType == "Date") {
                startMoment = moment.utc();
                endMoment = moment.utc();
            }

            if (specifier == "last rolling") {
                startTime = startMoment.subtract(offset, period).toISOString();
                endTime = endMoment.toISOString();
            } else {
                startTime = startMoment.subtract(offset, period).startOf(period).toISOString();
                endTime = endMoment.subtract(offset, period).endOf(period).toISOString();
            }

            _.forEach(me.changeEvents, (event) => {
                event(startTime, endTime);
            });
        };

        $(`#${me.options.id}`).change(function (e) {
            switch ($(`#${me.options.id}`).data("kendoDropDownList").value()) {
                case "TODAY":
                    setPresetDateRange("this", "day");
                    break;
                case "YESTERDAY":
                    setPresetDateRange("last", "day");
                    break;
                case "LAST_WEEK":
                    setPresetDateRange("last", "week");
                    break;
                case "LAST_MONTH":
                    setPresetDateRange("last", "month");
                    break;
                case "LAST_YEAR":
                    setPresetDateRange("last", "year");
                    break;
                case "LAST_QUARTER":
                    setPresetDateRange("last", "quarter");
                    break;
                case "LAST_ROLLING_WEEK":
                    setPresetDateRange("last rolling", "week");
                    break;
                case "LAST_ROLLING_MONTH":
                    setPresetDateRange("last rolling", "month");
                    break;
                case "LAST_ROLLING_YEAR":
                    setPresetDateRange("last rolling", "year");
                    break;
                case "LAST_ROLLING_QUARTER":
                    setPresetDateRange("last rolling", "quarter");
                    break;
                case "THIS_WEEK":
                    setPresetDateRange("this", "week");
                    break;
                case "THIS_MONTH":
                    setPresetDateRange("this", "month");
                    break;
                case "THIS_YEAR":
                    setPresetDateRange("this", "year");
                    break;
                case "THIS_QUARTER":
                    setPresetDateRange("this", "quarter");
            }
        });
    }
}
